/**
 * When fresh data is loaded from the server:
 * - refresh_order:start
 * - refresh_order:stop
 *
 * When products are added or removed from the cart:
 * - cart_change:start
 * - cart_change:stop
 *
 * When the attendee dropdowns have been rendered:
 * - attendee_dropdowns_initialized
 *
 * When the FooEvents ticket attendee fields have been loaded/reloaded:
 *  - attendees_reload
 */

const $ = window.jQuery;
const eventBus = $({});

export default eventBus;